<script lang="ts">
  export let pollsSum: number;
  import StepProgress from './StepProgress.svelte';
  import HeroButton from './HeroButton.svelte';
  import { createEventDispatcher } from 'svelte';
  import type { Item } from '../../types';

  export let options: { value: string; label: string }[] = [];
  export let selected: string = '';
  export let data: Item;
  export let title: string;
  export let step: number;

  const dispatch = createEventDispatcher();
  let selectedLocal = selected || (options.length > 0 ? options[0].value : '');

  function handleNext() {
    dispatch('next', {
      selected: [selectedLocal],
      questionKey: transformString(options[0]?.label || ''),
      question: options[0]?.label || '',
    });
  }

  function transformString(inputString: string) {
    const cleanedString = inputString.replace(/[^a-zA-Z0-9\s]/g, '');
    const lowercasedString = cleanedString.toLowerCase();
    return lowercasedString.replace(/\s+/g, '-');
  }
</script>

<div
  class="flex h-full w-full flex-col rounded-3xl bg-[#B3D18433] px-4 py-5 md:px-10 md:py-10"
>
  <StepProgress {pollsSum} {title} {step} />

  <div class="mb-4 space-y-3">
    <h5 class="text-normal !font-semibold leading-normal">
      {data.title.value}
    </h5>
    <p class="text-xs !font-medium leading-normal !text-[#111111A3]">
      Select one option:
    </p>
  </div>
  <div class="w-full space-y-3">
    {#each options as option}
      <label
        class="flex w-full cursor-pointer items-center gap-2 rounded-lg bg-white p-4"
      >
        <input
          type="radio"
          class="hidden"
          name="step4-radio"
          value={option.value}
          checked={selectedLocal === option.value}
          on:change={() => (selectedLocal = option.value)}
        />
        <div
          class="my-0.5 flex h-4 w-4 items-center justify-center rounded-full border"
          style="border-color: {selectedLocal === option.value
            ? '#086CD9'
            : '#E4E4E7'}"
        >
          {#if selectedLocal === option.value}
            <div class="h-1.5 w-1.5 rounded-full bg-[#086CD9]"></div>
          {/if}
        </div>
        <p class="grow-1 flex-1 text-sm !font-semibold leading-5">
          {option.label}
        </p>
      </label>
    {/each}
  </div>

  <div class="mt-auto w-full">
    <div class="mt-4 md:my-8">
      <HeroButton text={data.button.value} onClick={handleNext} />
    </div>
    <p
      class="hidden text-center text-xs !font-medium leading-normal !text-[#111111A3] md:block"
    >
      Zero Spam Policy
    </p>
  </div>
</div>
